import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'AwarenessCenter/WizardCampaign/SetupStep'

export const GET_PARTICIPANTS_INFO_ASYNC = createAsyncTypes('GET_PARTICIPANTS_INFO_ASYNC', typeKey)
export const FETCH_QUICK_LAUNCH_ASYNC = createAsyncTypes('FETCH_QUICK_LAUNCH', typeKey)
export const SUBMIT_QUICK_LAUNCH_ASYNC = createAsyncTypes('SUBMIT_QUICK_LAUNCH', typeKey)
export const GET_PARTICIPANTS_ASYNC = createAsyncTypes('GET_PARTICIPANTS', typeKey)
export const SEARCH_PARTICIPANTS_INFO_ASYNC = createAsyncTypes('SEARCH_PARTICIPANTS_INFO', typeKey)

export const VALIDATE_SETUP_STEP = `${typeKey}/VALIDATE_SETUP_STEP`
export const CHANGE_EXCLUDE_FILTER = `${typeKey}/CHANGE_EXCLUDE_FILTER`
export const CHANGE_MODAL_SEARCH = `${typeKey}/CHANGE_MODAL_SEARCH`
export const CHANGE_PAGE = `${typeKey}/CHANGE_PAGE`
export const CHANGE_SELECTION_DATA = `${typeKey}/CHANGE_SELECTION_DATA`
export const CHANGE_SENDING_REMINDERS_COUNT = `${typeKey}/CHANGE_SENDING_REMINDERS_COUNT`
export const SET_IS_LOCAL_NOTIFY_MANAGER_ENABLED = `${typeKey}/SET_IS_LOCAL_NOTIFY_MANAGER_ENABLED`
export const SET_IS_LOCAL_NOTIFY_MANAGER_ENABLED_WAS_CHANGED = `${typeKey}/SET_IS_LOCAL_NOTIFY_MANAGER_ENABLED_WAS_CHANGED`
